import React from 'react';


class RhinoLoading extends React.Component {

	render() {
		return (
			<div className='RhinoLoading'>
				<div className='loadingImgWrapper'>
					<img src='/img/loading.gif' alt='Loading' width='160' height='160' />
				</div>
				<div className='loadingImgPhoneWrapper'>
					<img src='/img/loading.gif' alt='Loading' width='80' height='80' />
				</div>
				<div className='loadingMessage'>{this.props.message}</div>
			</div>
		);
	}
}
export default RhinoLoading;